import '../../styles/layouts/theme.scss';
import {load} from '@shopify/theme-sections';
import 'preact/devtools';
import 'lazyvids';
import 'van11y-accessible-tab-panel-aria';

import accordionsInit from '../components/accordions';
import fadeInPage from '../components/fader';
import rteTablesInit from '../utils/rte-tables';
import rteVideosInit from '../utils/rte-videos';
import initRegionModal from '../components/region-modal';
import initProductCards from '../components/product-card';
import initAddressCards from '../components/address-card';
import imageWithTextSectionCounters from '../sections/image-with-text';
import initSectionOverlayScrollEffect from '../components/section-overlay-scrolling';

import '../components/web-vitals';

document.addEventListener('DOMContentLoaded', () => {
  load('*');
  accordionsInit();
  fadeInPage();
  rteTablesInit();
  rteVideosInit();
  initRegionModal();
  initProductCards();
  initAddressCards();
  imageWithTextSectionCounters();

  document.addEventListener('scroll', initSectionOverlayScrollEffect, {once: true});

  window.addEventListener('klaviyoForms', (event) => {
    if (event.detail.type !== 'submit') return;
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: 'klaviyo_form_submit',
      formId: event.detail.formId,
      email: event.detail.metaData.$email,
      Name: event.detail.metaData.Name,
      Birthday: event.detail.metaData.Birthday,
    });
  });
  /**
   * Dynamic imports are used to reduce main thread blocking time
   * during page load. Webpack handles code splitting these modules.
   */

  /**
   * Preact App entry point
   */
  import(/* webpackChunkName: 'app' */ '../../../app')
    .then((module) => module.default())
    .catch((error) => window.console.error('Could not load App module', error));
});
